import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadExcelIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4697_73098)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4697_73098",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16 0H0V16H16V0Z",
				fill: "#333333"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4697_73098)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M2 8.00277V14H14V8",
					stroke: "#141F2D",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11 5L8 2L5 5",
					stroke: "#141F2D",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.99731 10.6667V2",
					stroke: "#141F2D",
					strokeWidth: 2,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4697_73098",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgUploadExcelIcon;
